import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=60369b74"
import script from "./MainLoader.vue?vue&type=script&lang=js"
export * from "./MainLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports